var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithubSimple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63961 11.7925V9.8444C7.65849 9.60437 7.62606 9.36307 7.54448 9.13654C7.46289 8.91001 7.33402 8.70345 7.16643 8.53058C8.74705 8.35439 10.4082 7.75537 10.4082 5.00691C10.4081 4.30411 10.1377 3.62826 9.65313 3.11924C9.8826 2.50436 9.86637 1.82472 9.60783 1.22149C9.60783 1.22149 9.01384 1.04531 7.63961 1.9665C6.48587 1.65381 5.26969 1.65381 4.11595 1.9665C2.74172 1.04531 2.14773 1.22149 2.14773 1.22149C1.88918 1.82472 1.87296 2.50436 2.10243 3.11924C1.61421 3.63203 1.34359 4.31399 1.34736 5.02202C1.34736 7.75034 3.00851 8.34936 4.58912 8.54568C4.42351 8.71681 4.29579 8.9209 4.21426 9.14466C4.13274 9.36842 4.09924 9.60684 4.11595 9.8444V11.7925M4.11595 10.2823C1.59905 11.0374 1.59905 9.02389 0.592285 8.7722L4.11595 10.2823Z",
    stroke: "currentColor",
    strokeWidth: 1.00676,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubSimple);
export default __webpack_public_path__ + "static/media/github-simple.b45d03c84321e9719200b8076fb43c18.svg";
export { ForwardRef as ReactComponent };